import React from 'react';
import { useLayout } from '../../core/LayoutProvider';
import { Toolbar1 } from './Toolbar1';

function Toolbar () {
  return <Toolbar1 />;
}

export { Toolbar };
